module.exports = __webpack_public_path__ + "img/easy-candied-sweet-potatoes.4e08440d.jpg";